import { useContext, useEffect, useState } from 'react'
import { Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography, FormHelperText, Select, MenuItem } from '@mui/material'
import { LoadingButton } from '@mui/lab';
import { handleFieldChange } from '../../form/Form.js';
import { updateFileResourceProperties, getSiteSettings, decodeSharePointText } from '../data/index.js';
import bus from '../../utils/EventBus.js'
import Event from '../../utils/EventNames.js'
import TagsFormControl from '../TagsFormControl.js';
import CacheContext from '../../cache/CacheContext.js';
// import FeatureFlagsContext from '../../config/FeatureFlagsContext.js';

export default function EditResourceDialog({open, editResourceProperties, onClose, resourceCategories, isManager = false, driveConfig = undefined}) {
  const [editingFileProperties, setEditingFileProperties] = useState(editResourceProperties)
  const [resourceTags, setResourceTags] = useState(null)
  
  // const ff = useContext(FeatureFlagsContext)
  const cacheContext = useContext(CacheContext)
  
  const getResourceTags = async () => {
    const settings = await getSiteSettings(true, driveConfig)
    const tags = settings.resources.tags
    setResourceTags(tags ?? null)
  }

  useEffect(() => {
    if (editResourceProperties) {
      setEditingFileProperties({...editResourceProperties, description: editResourceProperties.description ? decodeSharePointText(editResourceProperties.description) : undefined})
      getResourceTags()
    }
  }, [editResourceProperties])

  const submitResourceEdits = async () => {
    const resourceId = editingFileProperties.resourceId
    bus.emit(Event.SHOW_PROGRESS_MODAL)
    try {
      bus.emit(Event.PROGRESS_MODAL_PROGRESS, {
        completed: 2,
        progress: 1
      })
      await updateFileResourceProperties(resourceId, editingFileProperties, false, driveConfig)
      bus.emit(Event.PROGRESS_MODAL_PROGRESS, {
        completed: 2,
        progress: 2
      })
    } catch (error) {

    } finally {
      bus.emit(Event.HIDE_PROGRESS_MODAL)
    }
    dialogClose(false, true)
  }

  const dialogClose = (navToMyResources = false, fileTouched = false) => {
    setEditingFileProperties(null)
    onClose(navToMyResources, fileTouched)
  }

  const getEditingFileCategoriesList = () => {
    let efc = editingFileProperties?.category
    if (efc) {
      efc = efc.replace(/category:/,'')
    }
    return Array.from(new Set([...resourceCategories, efc]))
  }

  return (
    <Dialog open={open} fullWidth maxWidth='md'>
      {editingFileProperties && <>
      <DialogTitle><Typography variant='body1' fontWeight={'bold'}>Edit Properties for {editingFileProperties?.title ?? (editingFileProperties?.fileName ?? '')}</Typography></DialogTitle>
      <DialogContent sx={{padding: 2}}>
        <Grid container rowGap={1.5} columnGap={1} alignItems={'center'}>
        <Grid item xs={4} sm={1.5} textAlign={'right'}>Category:</Grid>
        <Grid item xs={7} sm={3.5}>
          <Select multiple={false} 
            fullWidth
            value={editingFileProperties?.category ? editingFileProperties.category.replace(/category:/,'') : ''}
            required
            displayEmpty
            style={!editingFileProperties?.category ? { color: 'red'} : { color: 'inherit' }}
            onChange={(event) => handleFieldChange('category', event.target.value, editingFileProperties, setEditingFileProperties)}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <em>Select a primary category</em>;
              }
  
              return selected
            }}
            >
            { getEditingFileCategoriesList().filter( c => c).map( (c, idx) => {
              return (
              <MenuItem key={idx} value={c}>{c}</MenuItem>)}
            ) }
          </Select>
          </Grid>
          <Grid item xs={4} sm={1} textAlign={'right'}>Tags:</Grid>
          <Grid item xs={7} sm={5}>
            { resourceTags && 
              <TagsFormControl tagChoices={[...resourceTags].sort((a,b) => a.localeCompare(b))} tags={(editingFileProperties?.tags ?? []).map(t => t.replace(/tag:/,''))} setTags={(t) => handleFieldChange('tags', t, editingFileProperties, setEditingFileProperties)} key={'tags'} />
            }
          </Grid>
          <Grid item xs={4} sm={1.5} textAlign={'right'}>Title:</Grid><Grid item xs={7} sm={9}>
            <Stack direction={'row'} alignItems={'end'} columnGap={1}>
              <TextField type='text' size='small' 
                style={{width: '300px'}}
                variant='outlined'
                value={editingFileProperties?.title}
                inputProps={{ maxLength: 45 }}
                onChange={(event) => handleFieldChange('title', event.target.value, editingFileProperties, setEditingFileProperties)}
                />
              <FormHelperText>{(editingFileProperties?.title || '').length}/45</FormHelperText>
            </Stack>
          </Grid>
          <Grid item xs={4} sm={1.5} textAlign={'right'}>Description:</Grid><Grid item xs={7} sm={9}>
            <Stack direction={'row'} alignItems={'end'} columnGap={1}>
            <TextField type='text' multiline size='small' fullWidth 
              variant='outlined'
              value={editingFileProperties?.description}
              inputProps={{ maxLength: 200 }}
              onChange={(event) => handleFieldChange('description', event.target.value, editingFileProperties, setEditingFileProperties)}
              />
              <FormHelperText>{(editingFileProperties?.description || '').length}/200</FormHelperText>
            </Stack>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: '1.25rem' }}>
        <LoadingButton disabled={ !(editingFileProperties?.category)} onClick={() => { submitResourceEdits(); }}>Submit</LoadingButton>
        <Button onClick={() => { dialogClose(); }}>Close</Button>
      </DialogActions>
      </>
      }
    </Dialog>
  );
};